import {
  formatDate,
  IconEdit,
  Textarea,
  ButtonSecondary,
  ButtonSize,
  IconLoader,
  IconTrash,
} from '@ui/src';
import { DocumentCommentTypes } from '../types';
import useComment from './hooks/use-comment';

import cn from '../styles.module.css';

const DocumentComment = ({
  comment,
  documentId,
  commentsVisible,
  users,
}: DocumentCommentTypes) => {
  const {
    edit,
    setEdit,
    deleteComment,
    deleteInProgress,
    text,
    setText,
    isLoading,
    editComment,
  } = useComment({ comment });

  const currentUser = users?.find((item) => item.id === comment?.userId);

  let content;

  if (!edit) {
    content = (
      <div className={cn.documentSidepanelComment}>
        <div className={cn.documentSidepanelCommentTop}>
          <div className={cn.documentSidepanelCommentTopLeft}>
            <div>
              {currentUser
                ? `${currentUser?.profile?.firstName} ${currentUser?.profile?.lastName}`
                : `Employee ID: ${comment?.userId}`}
            </div>
            <div>
              {`${
                comment.updatedAt !== comment.createdAt ? 'updated at' : ''
              } ${formatDate(
                comment.updatedAt !== comment.createdAt
                  ? comment.updatedAt
                  : comment.createdAt,
                true,
              )}`}
            </div>
          </div>
          {commentsVisible && (
            <div className={cn.documentSidepanelCommentTopRight}>
              <button
                type="button"
                className={cn.documentEditButton}
                onClick={() => setEdit(true)}
                aria-label="Edit button"
              >
                <IconEdit width={16} height={16} />
              </button>
              <button
                type="button"
                aria-label="Delete button"
                onClick={() =>
                  deleteComment({
                    id: documentId as string,
                    commentId: comment.id,
                  })
                }
              >
                {deleteInProgress ? (
                  <IconLoader width={16} height={16} />
                ) : (
                  <IconTrash width={16} height={16} />
                )}
              </button>
            </div>
          )}
        </div>
        <div className={cn.documentSidepanelCommentText}>{comment.text}</div>
      </div>
    );
  } else {
    content = (
      <div className={cn.documentEditWrapper}>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          name="text"
          className={cn.documentEditTextarea}
          placeholder="Comment text..."
        />
        <div className={cn.documentEditControls}>
          <ButtonSecondary
            className={`button-white ${cn.documentEditSubmit}`}
            disabled={!text || isLoading}
            onClick={() => {
              setText('');
              editComment({
                id: documentId as string,
                commentId: comment.id,
                body: {
                  text,
                },
              });
            }}
            text={isLoading ? 'Loading...' : 'Edit'}
            size={ButtonSize.SMALL}
          />
          <ButtonSecondary
            className={`button-white ${cn.documentEditSubmit}`}
            onClick={() => setEdit(false)}
            text="Cancel"
            size={ButtonSize.SMALL}
          />
        </div>
      </div>
    );
  }

  return content;
};

export default DocumentComment;
